import { render, staticRenderFns } from "./MyLoadList.vue?vue&type=template&id=0c7c97f6&scoped=true"
import script from "./MyLoadList.vue?vue&type=script&lang=js"
export * from "./MyLoadList.vue?vue&type=script&lang=js"
import style0 from "./MyLoadList.vue?vue&type=style&index=0&id=0c7c97f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c97f6",
  null
  
)

export default component.exports